import { Navigate } from "react-router-dom";

export default function AdminRoute({ children }) {
  const admin = localStorage.getItem("ADMIN");

  // ❌ Not logged in → redirect to login
  if (!admin) {
    return <Navigate to="/adminlogin" replace />;
  }

  return children;
}
